import RecommendedProducts from '@digital-retail/recommended-products';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { constants } from '../../config/constants';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { CookieStorage } from '../../utils/CookieStorage';
import { GetRecommendedProducts } from '../../utils/RecommendedPoducts';
import { useRecommendedProductsHook } from './RecommendedProductsHook';

const RecommendedProductsContainer = ({ appCtx, pageName, slots, site }) => {
  const [displayCarousel, setDisplayCarousel] = useState(true);
  const [isFetching, setIsFetching] = useState(true);
  const [products, setProducts] = useState([]);
  const [title, setTitle] = useState('');
  const { deviceType, regionCode, zones, politicalId, priceGroupId, tenant } = appCtx;
  const labels = appCtx?.siteConfig?.textDictionary ?? {};

  const getPageId = () => {
    if (pageName === constants.PAGE_NAME.BRAND) {
      const url = window.location.href;
      const regex = /\/[brand|marca]+\/([^/]+)/;
      const match = url.match(regex);
      return match[1];
    }
    if (pageName === constants.PAGE_NAME.CATEGORY) {
      const url = window.location.href;
      const regex = /cat(g)*([0-9]+)/i;
      const match = url.match(regex);
      return match[0];
    }
    if (pageName === constants.PAGE_NAME.COLLECTION) {
      const url = window.location.href;
      const regex = /\/[collection|seleccion]+\/([^/]+)/;
      const match = url.match(regex);
      return match[1];
    }
    if (pageName === constants.PAGE_NAME.NO_RESULT) {
      return constants.PAGE_NAME.NO_RESULT;
    }
    if (pageName === constants.PAGE_NAME.SEARCH) {
      return new URL(window.location.href).searchParams.get('Ntt');
    }

    return undefined;
  };

  useEffect(() => {
    const pageId = getPageId();
    (async () => {
      const response = await GetRecommendedProducts({
        channel: 'standalone_web',
        contextId: CookieStorage.getCookie('contextID') || undefined,
        userId: CookieStorage.getCookie('USER_ID') || undefined,
        regionCode,
        slots,
        site,
        politicalId,
        priceGroupId,
        pageType: pageName?.toUpperCase() || undefined,
        pageId,
        zones,
        bypassCache: true,
      });

      const carouselData = response?.[0]?.data?.length > 0 ? response[0] : [];

      if (!carouselData) {
        setDisplayCarousel(false);
        return;
      }

      setTitle(carouselData.name);
      setProducts(carouselData.data);
      setIsFetching(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { onProductClick, onProductImpression } = useRecommendedProductsHook({
    title,
    slots,
    products,
    tenant,
  });

  const analytics = {
    onProductClick,
    onProductImpression,
  };

  return displayCarousel ? (
    <RecommendedProducts
      products={products}
      showSkeleton={isFetching}
      deviceType={deviceType}
      labels={{ title, podButtonText: labels.ADD_TO_CART, sponsoredText: '' }}
      analytics={analytics}
    />
  ) : null;
};

RecommendedProductsContainer.propTypes = {
  appCtx: PropTypes.object.isRequired,
  pageName: PropTypes.string.isRequired,
  slots: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
};

RecommendedProductsContainer.defaultProps = {};

export default withApplicationContext(RecommendedProductsContainer);
export { RecommendedProductsContainer };
